import { render, staticRenderFns } from "./AlertBanner.vue?vue&type=template&id=12e5f60a&scoped=true"
import script from "./AlertBanner.vue?vue&type=script&lang=js"
export * from "./AlertBanner.vue?vue&type=script&lang=js"
import style0 from "./AlertBanner.vue?vue&type=style&index=0&id=12e5f60a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e5f60a",
  null
  
)

export default component.exports